import React from 'react'
import { Link as RouterLink, useLoaderData,createBrowserRouter, createRoutesFromElements, Navigate, Await, BrowserRouter, Route, Routes, NavLink, useNavigate, useLocation, useOutlet} from 'react-router-dom'
const serverpy_template=`import os
import sys
from flask import Flask, jsonify, request, render_template
from flask_cors import CORS, cross_origin
from dotenv import load_dotenv
load_dotenv()
app = Flask(__name__)
cors = CORS(app, support_credentials=True)
sys.path.insert(0, os.path.dirname(__file__))
@app.route('/')
@cross_origin(supports_credentials=True)
def hello_word():
   return 'Hello World'
if __name__=='__main__': 
   app.run(host="0.0.0.0", port=5000, debug=True) 
`
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`
export default function APIPage() {
   return (
      <div className='text-left ml-[4px] mr-[4px] sm:m-auto sm:mt-8 w-auto md:w-[580px] lg:w-[780px]'>
         <h2 className='mb-4 flex text-lg structure__main__subttl'>Devcookbooks Open Source API</h2>
         <h3 className='mt-4 text-lg font-bold mb-2'>Quick Start</h3>
         <div className='mb-8 text-xs'>
            1. Issue your API token at user information page. To access the page, click your icon at right top side nav bar.<br/><br/>
            2. Request from your forntend<br/><br/>
            example (node):<br/>
            <pre className='primary-code-container'>
            {`const axios = require('axios') `}<br/>
            {'const options = { '}<br/>
            {`   method: 'GET', `}<br/>
            {`   url: 'https://api.devcookbooks.com/api/nsdq/aapl' `}<br/>
            {'} '}<br/>
            {'async function fetchData() { '}<br/>
            {'   try { '}<br/>
            {'      const res = await axios.request(options); '}<br/>
            {'      console.log(res.data); '}<br/>
            {'   } catch (error) { '}<br/>
            {'      console.error(error); '}<br/>
            {'   } '}<br/>
            {'} '}<br/>
            {'fetchData(); '}<br/>
            </pre><br/>
            example (react):<br/>
            <pre className='primary-code-container'>
            {`import axios from 'axios' `}<br/>
               {'async function fetchData(){ '}<br/>
               {'  try{'}<br/>
               {'       const {data:res}=await axios.get(`https://api.devcookbooks.com/api/nsdq/aapl`)'}<br/>
               {'       console.log(res)'}<br/>
               {' }catch(err){'}<br/>
               {'         console.log(err)'}<br/>
               {' }'}<br/>
               {'fetchData()'}<br/>
            </pre><br/>
            example (python):<br/>
            <pre className='primary-code-container'>
            {'import requests'}<br/>
            {`res = requests.get('https://api.devcookbooks.com/api/nsdq/aapl')`}<br/>
            {'print(res.json())'}<br/>
            </pre><br/>
         </div>
      </div>
   )
}